import useTenancy from './use-tenancy';

export default useTenancy;